import { useState, useEffect } from "react";
import { Grid2 } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Agendar from "../Components/Agendar";

const EspecialidadesInterna = () => {
    const navigate = useNavigate();
    const { interna } = useParams();
    const [espec, setEspec] = useState(null);
  
    useEffect(() => {
    axios.get(`https://api.sigmasystems.com.br/api/odontoluzzi/get-servicos?name=${interna}`)
        .then((response) => {
        const data = response.data;

        if (data.profissional) {
            data.profissional.sort((a, b) =>
            a.name.localeCompare(b.name, 'pt', { sensitivity: 'base' })
            );
        }

        setEspec(data);
        })
        .catch((error) => {
        console.error('Erro na requisição:', error);
        });
    }, [interna]);

    return(
        <div className="container">
            <Header/>
            <div className="content">
                <div className="intContainer">
                    <div className="intContent">
                        <div className="subTitle from-top">Especialidade</div>
                        <div className="title from-top">{espec?.servico?.name || ""}</div> 
                        <div className="titleLine from-top"/>
                        <div className="intEspec">
                            <div className="btnBack from-right" onClick={() => window.history.back()}>{'<< Voltar'}</div>
                            {espec?.servico?.foto ? <img className="intFoto from-left" src={`https://api.sigmasystems.com.br/api/odontoluzzi/uploads/especialidades/${espec?.servico?.foto}`}/> : <img className="intFoto from-left" src={`https://odontoluzzi.com.br/images/padrao/padraoServico.png`}/>}

                            <div className="intText from-right">{espec?.servico?.text || ''}</div>
                            {espec?.profissional ? (<div className="intTitle2 from-left">Profissionais</div>):('')}
                            

                            <Grid2 columns={{ xs:4, sm:8, md:12}} className='from-bottom' container spacing={2} justifyContent={'left'}>
                                <Grid2 item>
                                    <Grid2 container justifyContent={'left'} spacing={3} width={'100%'} marginLeft={0}>
                                        {espec?.profissional?.map((prof, index) => (
                                            <div className="equipeCard" key={index}>
                                                {prof?.foto ? <img className="equipeFoto" src={`https://api.sigmasystems.com.br/api/odontoluzzi/uploads/equipe/${prof.foto}`}/> : <img className="equipeFoto" src={"https://odontoluzzi.com.br/images/padrao/padraoEquipe.png"}/>}
                                                <div className="equipeName">{prof?.name || ''}</div>
                                                <div className="equipeTitle">{prof?.titulo}</div>
                                                <div className="equipeCro">CRO-{prof?.cro_uf} {prof?.cro}</div>
                                            </div>
                                        ))}    
                                    </Grid2>                    
                                </Grid2>
                            </Grid2>
                        </div>
                    </div>
                </div>
                <Agendar/>
            </div>
            <Footer/>
        </div>
    )
}
export default EspecialidadesInterna;